import { useRouteLoaderData } from "@remix-run/react";
import { z } from "zod";
import { type loader } from "~/root.server";
import { throwIfUndefined } from "./throw-if";

const RootLoaderDataSchema = z.object({
  requestType: z.enum(["Landing", "User", "UserApp", "Revision"]),

  baseHomeUrl: z.string(),
  release: z.string().optional(),

  sentryDSN: z.string(),
  sentryEnvironment: z.string(),
  sentryRelease: z.string().optional(),
  sentryUserId: z.string().optional(),
  sentryUsername: z.string().optional(),

  posthog: z.object({
    apiKey: z.string(),
    host: z.string(),
    debug: z.boolean(),
  }),

  user: z
    .object({
      id: z.string(),
      username: z.string(),
      activeSubscription: z.string().nullable(),
    })
    .optional(),

  urls: z.object({
    logoutUrl: z.string(),
    dashboardUrl: z.string(),
    walletUrl: z.string(),
    newPaymentUrl: z.string(),
  }),

  hosts: z.object({
    protocol: z.string(),
    landingHost: z.string(),
    userAppHost: z.string(),
  }),
});
export type RootLoaderData = z.infer<typeof RootLoaderDataSchema>;

export const getRootLoaderDataFromWindow = () =>
  RootLoaderDataSchema.safeParse(window.__remixContext.state.loaderData?.root);

export const useRootLoaderData = () =>
  throwIfUndefined(useRouteLoaderData<typeof loader>("root"), "root loader returned undefined");
